import { render, staticRenderFns } from "./emphasis.vue?vue&type=template&id=3b73ebd0&scoped=true"
var script = {}
import style0 from "./emphasis.vue?vue&type=style&index=0&id=3b73ebd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b73ebd0",
  null
  
)

export default component.exports